module.exports = __webpack_public_path__ + "img/sneaker1.f5b1f1ba.png";